export type Attachment = {
  title: string;
  field: string;
  canAdd?: boolean;
  file?: File;
};
export type AttachmentFileDraftCGS = {
  file_name?: string;
  path?: string;
};
export interface UploadedAttachments {
  monitoring_attachments: string[];
}

export interface UploadedAttachmentsCGS {
  machine_equipment_equipment?: AttachmentFileDraftCGS[];
  vehicles_special_technic?: AttachmentFileDraftCGS[];
  purchase_building_land?: AttachmentFileDraftCGS[];
  building_repairs?: AttachmentFileDraftCGS[];
  funds_turnover?: AttachmentFileDraftCGS[];
  repayment_amount?: AttachmentFileDraftCGS[];
  sign_image?: AttachmentFileDraftCGS[];
  additional_documents?: (AttachmentFileDraftCGS & { original_path?: string; signed_url?: string })[];
}

export const ATTACHMENT_KEYS = [
  "machine_equipment_equipment",
  "vehicles_special_technic",
  "purchase_building_land",
  "building_repairs",
  "funds_turnover",
  "repayment_amount",
  "sign_image",
] as const;

export type AttachmentKey = typeof ATTACHMENT_KEYS[number];
